import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  
  dateFilterUpdated: EventEmitter<any> = new EventEmitter<any>();
  dateDueFilterUpdated: EventEmitter<any> = new EventEmitter<any>();
  customerFilterUpdated: EventEmitter<any> = new EventEmitter<any>();
  customerSortUpdated: EventEmitter<any> = new EventEmitter<any>();
  ageSortUpdated: EventEmitter<any> = new EventEmitter<any>();

  csvStartDate: any = '';
  csvEndDate: any = '';
csvDueStartDate: any = '';
  csvDueEndDate: any = '';
  constructor() { }


  setDateFilter(filter: any) {    
    console.log(filter);
    
    this.dateFilterUpdated.emit(filter);
  }

  setDueDateFilter(filter: any) {    
    this.dateDueFilterUpdated.emit(filter);
  }

  selectedCustomerFilter(filter: any) {    
    this.customerFilterUpdated.emit(filter);
  }

  
  sortByName(filter: any) {    
    this.customerSortUpdated.emit(filter);    
  }

   sortByAge(filter: any) {    
    this.ageSortUpdated.emit(filter);
  }

}
